import * as angular from "angular";
import {IController, IFilterService} from "angular";
import * as _ from "lodash"
import {VehicleType} from "../../../commons/types/vehicle.type";
import {TaskModel} from "../../../tasks/models/task.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class PlanningRouteTasksEditableTableRowComponent implements IController {

  planningRouteTasksTableCtrl: IController;
  task: TaskModel;
  taskAnalysis: any;
  index: any;
  isHighlighted: any;
  hasForcedStartOption: any;
  isForcedStart: any;
  isForcedStartDisabled: any;
  hasForcedEndOption: any;
  isForcedEnd: any;
  isForcedEndDisabled: any;
  isBundle: any;
  isEditable: any;
  selectedKeys: any;
  toggle: Function;
  onForcedStartToggle: Function;
  onForcedEndToggle: Function;

  public purposeToServiceType: any;
  public configZoneId: undefined;
  public bindingSubTask: any;
  public logisticsVehiclesRefList: any[];
  public omsOrderIds: string[];
  public bundleServiceExternalIds: string[];
  public bundleWeight: string;

  constructor(private $task,
              private tasksConstants,
              private splitService: SplitService,
              private $filter,
              private commonsService: CommonsService) {
    this.purposeToServiceType = this.tasksConstants.purposeToServiceType;
  }

  $onInit() {

    this.configZoneId = this.splitService.getTimeZone();
    if (this.task.subTasks && (this.task.taskSpec.purpose === 'StartRoute' || this.task.taskSpec.purpose === 'EndRoute')) {

      this.bindingSubTask = _.find(this.task.subTasks, (st) => {
        return _.find(st.actions, (ac) => {
          return ac.type === "VehicleBinding";
        })!!
      })

      this._setLogisticsVehiclesRefList(this.bindingSubTask);
    }

    if (this.isBundle) {
      this.bundleServiceExternalIds = _.flatMap(this.task.bundledTaskList, 'serviceExternalId');
      let hasAnyWeight = false;
      let totalBundleWeight: number = this.task.bundledTaskList?.reduce((sum, task) => {

        const weight = this.commonsService.getPackageWeight(task.packageList[0]);
        if (typeof weight !== "undefined") {
          hasAnyWeight = true;
        }

        sum += typeof weight === "number" ? +weight : 0;
        return sum;
      }, 0)

      this.bundleWeight = hasAnyWeight ? this.$filter('bringozWeight')(totalBundleWeight, true) : '--';
    }

  };

  onForcedStart() {
    const taskIds = angular.copy(this.task.taskIdList || []);

    if (this.task.taskType === 'BundledStopover') {
      taskIds.push(this.task.id);
    }

    this.onForcedStartToggle({taskIds: taskIds});
  }

  onForcedEnd() {
    const taskIds = angular.copy(this.task.taskIdList || []);

    if (this.task.taskType === 'BundledStopover') {
      taskIds.push(this.task.id);
    }
    this.onForcedEndToggle({taskIds: taskIds});
  }

  _setLogisticsVehiclesRefList(bindingSubTask) {
    this.logisticsVehiclesRefList = [];
    if (!!bindingSubTask) {
      _.forEach(bindingSubTask.actions, (ac) => {
        if (ac.type === "VehicleBinding") {
          const logisticsVehicleReference = _.get(ac, 'logisticsVehicleReference');
          _.get(logisticsVehicleReference, 'vehicleType') === VehicleType.Trailer ?
            this.logisticsVehiclesRefList.push(logisticsVehicleReference) : this.logisticsVehiclesRefList.unshift(logisticsVehicleReference)
        }
      })
    }
  }

  private _getTasksOmsOrderIds(tasks: any) {
    const orderIds = tasks
      .filter(t => {
        return !!t.serviceInfo?.omsOrderReference
      })
      .flatMap(t => {
        return t.serviceInfo.omsOrderReference.id
      });

    //Uniq array
    return orderIds.filter((item, i, ar) => ar.indexOf(item) === i);
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRouteTasksEditableTableRow', {
    require: {
      planningRouteTasksTableCtrl: '^planningRouteTasksEditableTable'
    },
    bindings: {
      task: '<',
      taskAnalysis: '<',
      index: '<',
      isHighlighted: '<',
      hasForcedStartOption: '<?',
      isForcedStart: '<?',
      isForcedStartDisabled: '<?',
      hasForcedEndOption: '<?',
      isForcedEnd: '<?',
      isForcedEndDisabled: '<?',
      isBundle: '<',
      isEditable: '<?',
      selectedKeys: '<',
      toggle: '&',
      onForcedStartToggle: '&',
      onForcedEndToggle: '&'
    },
    template: require('./planning-route-tasks-editable-table-row.html').default,
    controller: PlanningRouteTasksEditableTableRowComponent
  });
